import React from 'react';
import { Button, Tooltip, Modal, Space } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useResetToDefault } from '@hooks/useCustomerLevelPersistence';
import { getPersistentHashKey } from '@utils/persistenceUtil';

const PresetControls: React.FC = () => {
  const shouldDisplayReset = window.location.pathname.includes('preset');

  const { resetToDefault, isResetting } = useResetToDefault();

  const handleResetToDefault = () => {
    Modal.confirm({
      title: 'Reset to Default',
      content:
        'This will reset your configuration to the default. Any personalizations will be lost.',
      okText: 'Reset',
      cancelText: 'Cancel',
      okType: 'danger',
      onOk: () => {
        // Get current key from URL in case it changed
        const currentKey = getPersistentHashKey();
        resetToDefault(currentKey);
      },
    });
  };

  return (
    <Space direction="vertical">
      {shouldDisplayReset && (
        <Tooltip title="Reset your configuration to default">
          <Button
            type="text"
            size="small"
            icon={<ReloadOutlined />}
            onClick={handleResetToDefault}
            loading={isResetting}
          >
            Reset to Default
          </Button>
        </Tooltip>
      )}
    </Space>
  );
};

export default PresetControls;
